// eslint-disable-next-line import/no-cycle
import { DEFAULT_TABLE_PAGE_SIZE } from '@api/common/paging-utils';
import { apiClientManager } from '@common/api';
export async function getLicenseActivationLink() {
    const res = await apiClientManager.getClient().get('/api/license/activate');
    return res.data.activationUrl;
}
export async function postLicense(license) {
    const res = await apiClientManager.getClient().post('/api/license', {
        token: license
    });
    return res.data;
}
export async function readLicense() {
    const res = await apiClientManager.getClient().get('/api/license');
    return res.data;
}
export async function downloadReport() {
    const res = await apiClientManager
        .getClient()
        .get('/api/usage-stats/report');
    return res.data;
}
export async function sendUsage() {
    await apiClientManager.getClient().post('/api/usage-stats/sending-status');
}
export async function synchronizeLicense() {
    const response = await apiClientManager
        .getClient()
        .post('/api/license/sync');
    return response.data;
}
export async function licenseHistory(filters, limit = DEFAULT_TABLE_PAGE_SIZE) {
    const params = await makeLicenseEventsArgs(filters, limit);
    const res = await apiClientManager
        .getClient()
        .get('/api/license/audit-logs', {
        params
    });
    return res.data;
}
export async function generateNewPublicKey() {
    const res = await apiClientManager
        .getClient()
        .post('/api/license/public-key');
    return res;
}
async function makeLicenseEventsArgs(params, limit) {
    const { ...restParams } = params;
    return {
        limit: limit ? `${limit}` : undefined,
        ...restParams
    };
}
